import React from 'react';
import { EmployerLayout } from '../JobPostPricing/EmployerLayout';
import Dashboard from './Dashboard';
import { useNavigate } from 'react-router-dom';

export const InterviewDashboard = () => {
  const navigate = useNavigate();
  return (
    <EmployerLayout>
      <div className="flex flex-col w-full">
        <div className="flex-1 flex flex-col gap-8">
          <Dashboard />
        </div>
      </div>
    </EmployerLayout>
  );
};
